import styled from '@emotion/styled'

export const SeparatorContainer = styled.section<{ bgColour?: string }>`
  height: 100%;
  padding: 5rem 0;
  width: 100%;
  background-color: ${({ theme, bgColour }) =>
    bgColour || theme.palette.primary.main};

  h1,
  h2,
  h3,
  h4 {
    color: #fff;
    text-align: center;
    margin-bottom: 2rem;
  }

  p {
    color: #fff;
    margin-bottom: 2rem;
    text-align: center;
  }

  button,
  a {
    font-weight: 700;
  }
`
